import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "store/baseUrls";
import { xApiKey } from "store/apiKeys";
import type { Search } from "./search.model";

export const searchApi = createApi({
  reducerPath: "searchApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Accept", "application/json");
      headers.set("X-Api-Key", xApiKey);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getSearch: builder.query<Search, { searchQuery: string }>({
      query: ({ searchQuery }) => `/v1/search?q=${searchQuery}&maxSize=200`,
      transformResponse: (data: { total: number; list: Search }) => data.list,
    }),
    getSearchInArtist: builder.query<
      Search,
      { artistId: string; searchQuery: string }
    >({
      query: ({ artistId, searchQuery }) => ({
        url: `/v1/search/artist?q=${searchQuery}&artistId=${artistId}&maxSize=100`,
        method: "GET",
      }),
      transformResponse: (data: { total: number; list: Search }) => data.list,
    }),
  }),
});

export const {
  useGetSearchQuery,
  useGetSearchInArtistQuery,
  util: searchApiUtil,
} = searchApi;
